// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__1we06","link":"navigation_link__wgqQX"};